import { render, staticRenderFns } from "./FailedLabelDetails.vue?vue&type=template&id=44641a16&scoped=true"
import script from "./FailedLabelDetails.vue?vue&type=script&lang=js"
export * from "./FailedLabelDetails.vue?vue&type=script&lang=js"
import style0 from "./FailedLabelDetails.vue?vue&type=style&index=0&id=44641a16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44641a16",
  null
  
)

export default component.exports